export const requestedMeasureFields = (measures = []) =>
  measures.map((measure) => measure?.vc_fieldName).filter(Boolean);

const containsRequestedMeasures = (registers, measures) => {
  if (!Array.isArray(registers) || !registers.length) return false;
  const requested = requestedMeasureFields(measures);
  const available = new Set(
    registers
      .filter(
        (item) =>
          item?.nu_value !== null &&
          item?.nu_value !== undefined &&
          Number.isFinite(Number(item.nu_value))
      )
      .map((item) => item?.vc_field)
      .filter(Boolean)
  );
  return requested.length === 0 || requested.every((field) => available.has(field));
};

const pendingRegisters = (value) => {
  if (Array.isArray(value)) return value;
  if (value?.type !== "total-view-pending" || !value?.batches) return null;

  const latestBatch = Object.values(value.batches)
    .filter((batch) => Array.isArray(batch?.registers))
    .sort((left, right) => new Date(right.updatedAt) - new Date(left.updatedAt))[0];
  return latestBatch?.registers || null;
};

export const normalizeCachedSnapshot = (response, measures = []) => {
  if (!response) return null;

  const registers = [pendingRegisters(response.json_updating), response.json_data]
    .find((candidate) => containsRequestedMeasures(candidate, measures));

  if (!registers) return null;
  const registerDate = registers.find((item) => item?.createdAt)?.createdAt;

  return {
    ...response,
    createdAt: registerDate || response.updatedAt || response.createdAt,
    json_data: registers,
  };
};

export const normalizeLatestEventSnapshot = (response) => {
  const event = response?.data?.[0];
  if (!event || !Array.isArray(event.registros) || !event.registros.length) return null;

  return {
    ...event,
    json_data: event.registros,
  };
};

export const buildLatestEventParams = (selectedId, measures = [], includeBattery = false) => ({
  $limit: 1,
  $skip: 0,
  $where: [{ id_dispositivoArea: selectedId }],
  $or: {
    vc_field: [
      ...requestedMeasureFields(measures),
      ...(includeBattery ? ["BAT"] : []),
    ],
  },
  $order: [["updatedAt", "DESC"]],
});
